// extracted by mini-css-extract-plugin
export default {"container":"footer_container__QbKC-","footer":"footer_footer__NjMd5","left":"footer_left__Q2OtD","right":"footer_right__X6v5+"};